import RegistrationLimitsModal from '../../components/RegistrationModals/RegistrationLimitsModal/RegistrationLimitsModal';
import { Box } from '@bonanza-social/moonlight';
import { Screen } from '@bonanza-social/navigation';

function RegistrationLimitsModalScreen() {
  return (
    <Screen paddingHorizontal="space-100">
      <Box flex={1} justifyContent="center">
        <RegistrationLimitsModal />
      </Box>
    </Screen>
  );
}
export default RegistrationLimitsModalScreen;
